import apiBase from "../../api/axios";

export const getTalentosService = async (page = 1, search = "") => {
  let url = `v1/talentos-global/talentos/?page=${page}`;
  if (search) {
    url += `&search=${encodeURIComponent(search)}`;
  }
  const response = await apiBase.get(url);
  return response.data;
};

export const createTalentoService = async (payload) => {
  const response = await apiBase.post("v1/talentos-global/talentos/", payload);
  return response.data;
};

export const getTalentoByIdService = async (id) => {
  const response = await apiBase.get(`v1/talentos-global/talentos/${id}/`);
  return response.data;
};

export const updateTalentoService = async (id, payload) => {
  const response = await apiBase.put(`v1/talentos-global/talentos/${id}/`, payload);
  return response.data;
};

export const toggleTalentoActiveService = async (id) => {
  const response = await apiBase.patch(`v1/talentos-global/talentos/${id}/toggle-status/`);
  return response.data;
};

export const getTalentosSelectoresService = async (search = "") => {
  const response = await apiBase.get(
    "v1/talentos-global/selectores/talentos/",
    {
      params: { search },
    }
  );
  return response.data;
};

export const getFrasesDisponiblesService = async (talentoId, random = false) => {
  const params = {};
  
  if (talentoId) {
    params.talento = talentoId;
  }
  
  if (random) {
    params.is_random = true;
  }
  
  const response = await apiBase.get(
    "v1/talentos-global/frases-disponibles/",
    { params }
  );
  return response.data;
};

// Servicios para configuración de frases
export const getConfiguracionesService = async () => {
  const response = await apiBase.get("v1/talentos-global/configuracion-vs/");
  return response.data;
};

export const createConfiguracionService = async (frase1Id, frase2Id) => {
  const payload = {
    configuracion_talentos_global: 1,
    frase_1: frase1Id,
    frase_2: frase2Id,
  };
  const response = await apiBase.post("v1/talentos-global/configuracion-vs/", payload);
  return response.data;
};

export const updateConfiguracionService = async (id, frase1Id, frase2Id, orden = null) => {
  const payload = {
    frase_1: frase1Id,
    frase_2: frase2Id,
    //orden: orden,
  };
  const response = await apiBase.put(`v1/talentos-global/configuracion-vs/${id}/`, payload);
  return response.data;
};

export const patchConfiguracionService = async (id, data) => {
  const response = await apiBase.patch(`v1/talentos-global/configuracion-vs/${id}/`, data);
  return response.data;
};

export const deleteConfiguracionService = async (id) => {
  const response = await apiBase.delete(`v1/talentos-global/configuracion-vs/${id}/`);
  return response.data;
};

// Servicios para frases respuesta
export const getFrasesRespuestaService = async (page = 1, search = "") => {
  let url = `v1/talentos-global/frases-respuesta/?page=${page}`;
  if (search) {
    url += `&search=${encodeURIComponent(search)}`;
  }
  const response = await apiBase.get(url);
  return response.data;
};

export const getFraseRespuestaByIdService = async (id) => {
  const response = await apiBase.get(`v1/talentos-global/frases-respuesta/${id}/`);
  return response.data;
};

export const updateFraseRespuestaService = async (id, payload) => {
  const response = await apiBase.put(`v1/talentos-global/frases-respuesta/${id}/`, payload);
  return response.data;
};

// Servicio para obtener los talentos del usuario
export const getMisTalentosService = async () => {
  const response = await apiBase.get("v1/mis-talentos/");
  return response.data;
};
